import type { RequestFormValues } from 'legal/types/requestFormTypes'

export const FormId = 'privacy.rights.form'

export const enum FormFieldNames {
	Category = 'category',
	FirstName = 'firstName',
	LastName = 'lastName',
	Email = 'email',
	State = 'state',
	Message = 'message',
}

export const enum FormFieldIds {
	Category = 'privacy-rights-form-category',
	FirstName = 'privacy-rights-form-firstName',
	LastName = 'privacy-rights-form-lastName',
	Email = 'privacy-rights-form-email',
	State = 'privacy-rights-form-state',
	Message = 'privacy-rights-form-message',
	SubmitButton = 'privacy-rights-form-submit',
}

export const staticDefaultValues: RequestFormValues = {
	[FormFieldNames.Category]: '',
	[FormFieldNames.FirstName]: '',
	[FormFieldNames.LastName]: '',
	[FormFieldNames.Email]: '',
	[FormFieldNames.State]: '',
	[FormFieldNames.Message]: '',
}
